module.exports = __webpack_public_path__ + "static/media/DSC_0209.911fa0ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0209.jpg
// module id = 568
// module chunks = 0